import React from 'react';
import { TFunction } from 'react-i18next';
import { FormikProps } from 'formik';
import {
  ModalView,
  withTranslation,
  Stack,
  Button,
  Form,
  Text,
  Trans,
} from '@piwikpro/ui-components';
import { withInject } from '@piwikpro/platform';
import { BillingService } from '../../BillingService';

interface InjectedProps {
  billingService: BillingService
}

export interface Props extends InjectedProps {
  onClose: () => void
  t: TFunction
}

export const ManagePaymentModal: React.FC<Props> = ({
  billingService,
  onClose,
  t,
}) => {
  const handleSubmit = async (values: undefined, api: FormikProps<undefined>) => {
    try {
      const response = await billingService.getSubscriptionManagementUrl();
      window.open(response.update_payment_method);
      onClose();
    // eslint-disable-next-line no-empty
    } catch {}

    api.setSubmitting(false);
  };

  return (
    <Form
      id="manage-payment-modal"
      onSubmit={handleSubmit}
      initialValues={{}}
      validationSchema={() => true}
      render={api => (
        <ModalView
          title={t('paddle.billing.manage-payment-modal.title')}
          actions={(
            <Stack spacing="narrow" horizontalAlignment="right" verticalAlignment="center">
              <Button
                type="button"
                text={t('components:cancel')}
                appearance="default"
                onClick={onClose}
              />
              <Button
                pending={api.isSubmitting}
                disabled={api.isSubmitting}
                onClick={() => api.submitForm()}
                text={t('paddle.billing.manage-payment-modal.redirect-button')}
                appearance="primary"
              />
            </Stack>
          )}
          onClose={onClose}
        >
          <Stack vertical>
            <Stack.Item fill>
              <Text as="p">
                <Trans
                  i18nKey="paddle.billing.manage-payment-modal.text"
                  components={[<b>text</b>]}
                />
              </Text>
            </Stack.Item>
            <Stack.Item fill>
              <Text as="p">
                {t('paddle.billing.manage-payment-modal.text-confirmation')}
              </Text>
            </Stack.Item>
          </Stack>
        </ModalView>
      )}
    />
  );
};

export default withInject<InjectedProps>({
  billingService: 'MarketingCrate.billingService',
})(withTranslation(['administration'])(ManagePaymentModal));
